import { Record } from 'immutable';

export var NotificationRecord = new Record({
  body: null,
  click_action: null,
  icon: null,
  title: null,
})


// WEBPACK FOOTER //
// ./src/core/devices/notification.js